import React from 'react';
import { Editor } from 'slate';
import { AulaPlugin } from '../plugins';
import { blockQuoteType, isBlockQuoteElement } from './blockQuoteType';
import { getCurrentNodeType } from '../../lib/queries';

export const blockQuote: AulaPlugin = (editableProps) => ({
  ...editableProps,
  renderElement: (props) => {
    const { element, attributes, children } = props;
    if (isBlockQuoteElement(element)) {
      return <blockquote {...attributes}>{children}</blockquote>;
    }
    return editableProps.renderElement?.(props) || <p />;
  },
});

export const isCurrentBlockQuote = (editor: Editor) => {
  const currentNodeType = getCurrentNodeType(editor);
  return currentNodeType === blockQuoteType;
};
